var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScientific(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 3C8.25 2.58579 8.58579 2.25 9 2.25H15C15.4142 2.25 15.75 2.58579 15.75 3C15.75 3.41421 15.4142 3.75 15 3.75H9C8.58579 3.75 8.25 3.41421 8.25 3Z",
    fill: "#A2A2A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.25 9C9.25 8.58579 9.58579 8.25 10 8.25H14C14.4142 8.25 14.75 8.58579 14.75 9C14.75 9.41421 14.4142 9.75 14 9.75H10C9.58579 9.75 9.25 9.41421 9.25 9Z",
    fill: "#A2A2A2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0009 2.25C10.4151 2.25 10.7509 2.58579 10.7509 3V9C10.7509 9.08741 10.7356 9.17416 10.7057 9.25631L6.70804 20.25H17.2938L13.2961 9.25631C13.2662 9.17416 13.2509 9.08741 13.2509 9V3C13.2509 2.58579 13.5867 2.25 14.0009 2.25C14.4151 2.25 14.7509 2.58579 14.7509 3V8.86787L18.6939 19.7112C18.7799 19.9001 18.8243 20.1054 18.8241 20.3133C18.8238 20.5378 18.7714 20.7592 18.671 20.96C18.5706 21.1609 18.4249 21.3356 18.2454 21.4706C18.066 21.6055 17.8576 21.6969 17.6368 21.7376C17.592 21.7458 17.5465 21.75 17.5009 21.75H6.50091C6.45533 21.75 6.40984 21.7458 6.36502 21.7376C6.1442 21.6969 5.93585 21.6055 5.75638 21.4706C5.57691 21.3356 5.43123 21.1609 5.33082 20.96C5.2304 20.7592 5.178 20.5378 5.17774 20.3133C5.17749 20.1054 5.22196 19.9 5.30789 19.7112L9.25091 8.86787V3C9.25091 2.58579 9.58669 2.25 10.0009 2.25Z",
    fill: "#A2A2A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScientific);
export default __webpack_public_path__ + "static/media/scientific.8d0acebcb43687ea58a29d4f79c796e1.svg";
export { ForwardRef as ReactComponent };